import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { Row, Col } from "react-bootstrap";
import Button from "react-bootstrap/Button";
import ReportList from "../../../common/ReportList";
import Constants from "../../../../common/Constants";
// import { formatDateTime } from "../../../../common/Validations";
// import moment from "moment";
import { formatDateTime } from "../../../../common/Validations";
import PrintStatusReports from "./PrintStatusReports";

const ReworkReports = () => {
  const { t } = useTranslation();
  const [displayFilter, setDisplayFilter] = useState(false);
  const [selectedRows, setSelectedRows] = useState(false);
  const [openViewJobcardCode, setOpenViewJobcardCode] = useState(false);
  const columnsData = [
    {
      name: t("msg_reports.msg_jobstatus_report.col_jobcard"),
      selector: (row) => row.jobcard,
      sortable: true,
      width: "160px",
      cell: (row) => (
        <>
          <span className="bg-table-status bg-table-new-status">
            {row.jobcard}
          </span>
        </>
      ),
      conditionalCellStyles: [
        {
          when: (row) => true, // apply to all rows
          style: {
            position: "sticky",
            left: "0px",
            background: "#fff",
            zIndex: 2,
            boxShadow: "2px 0 5px -2px #ddd",
          },
        },
      ],
    },
    {
      name: t("msg_reports.msg_jobstatus_report.col_size"),
      selector: (row) => row.sizeCode,
      sortable: true,
      width: "190px",
      cell: (row) => (
        <div>
          <p className="m-0 p-0 pt-1 fw-bold ">{row.sizeCode} </p>
          <p className="m-0 p-0 ">{row.sizeName} </p>
        </div>
      ),
    },
    {
      name: "From Department",
      selector: (row) => row.fromDeptName   ,
      sortable: true,
      width: "210px",
      cell: (row) => (
         <>
          <span className="bg-table-status bg-table-second-status">
            {row.fromDeptCode} - {row.fromDeptName}
          </span>
        </>
      ),
    },
    {
      name: "Issued Operator Name",
      selector: (row) => row.operatorUserId,
      sortable: true,
      width: "220px",
      cell: (row) => (
          <>
          <span className="bg-table-status bg-table-second-status">
            {row.operatorUserId} - {row.operatorUserName}
          </span>
        </>
      ),
    },
    {
      name: "Rework Issue Date",
      selector: (row) => row.dbDateTimeCreated,
      sortable: true,
      width: "200px",
      cell: (row) => (
        <div>
          <p className="m-0 p-0 pt-1">{formatDateTime(row.dbDateTimeCreated)}</p>
        </div>
      ),
    },
    {
      name: "Reason name",
      selector: (row) => row.reasonName,
      sortable: true,
      width: "200px",
      cell: (row) => (
        <div>
          <p className="m-0 p-0 pt-1">{row.reasonName}</p>
        </div>
      ),
    },
    {
      name: "Department Name",
      selector: (row) => row.toDeptName,
      sortable: true,
      width: "210px",
      cell: (row) => (
         <>
          <span className="bg-table-status bg-table-second-status">
            {row.toDeptName}
          </span>
        </>
      ),
    },
    {
      name: "Quantity",
      selector: (row) => row.count,
      sortable: true,
      width: "130px",
      cell: (row) => (
        <div>
          <span className="bg-table-status bg-table-primary-status">
            {row.count}
          </span>
        </div>
      ),
    },
    {
      name: "Rework Done Operator",
      selector: (row) => row.operatorUserName,
      sortable: true,
      width: "220px",
      cell: (row) => (
       <>
          <span className="bg-table-status bg-table-second-status">
            {row.assignedFirstName}
          </span>
        </>
      ),
    },
    {
      name: "Completion Date",
      selector: (row) => row.finalStopDateTime,
      sortable: true,
      width: "170px",
      cell: (row) => (
         <div>
          <p className="m-0 p-0 pt-1">{formatDateTime(row.finalStopDateTime)}</p>
        </div>
      ),
    },
    {
      name: "Machine Used",
      selector: (row) => row.toMachineCode,
      sortable: true,
      width: "200px",
      cell: (row) => (
       <>
          <span className="bg-table-status bg-table-second-status">
            {row.toMachineCode} - {row.toMachineName}
          </span>
        </>
      ),
    },
    {
      name: "Start Time",
      selector: (row) => row.initialStartDateTime,
      sortable: true,
      width: "180px",
      cell: (row) => (
         <div>
          <p className="m-0 p-0 pt-1">{formatDateTime(row.initialStartDateTime)}</p>
        </div>
      ),
    },
    {
      name: "End Time",
      selector: (row) => row.finalStopDateTime,
      sortable: true,
      width: "180px",
      cell: (row) => (
       <div>
          <p className="m-0 p-0 pt-1">{formatDateTime(row.finalStopDateTime)}</p>
        </div>
      ),
    },
    {
      name: "Duration",
      selector: (row) => row.actualDuration,
      sortable: true,
      width: "120px",
      cell: (row) => (
       <div>
          <p className="m-0 p-0 pt-1">{row.actualDuration}</p>
        </div>
      ),
    },
    {
      name: "OK Qty",
      selector: (row) => row.reworkOKQuanity,
      sortable: true,
      width: "120px",
      cell: (row) => (
        row.reworkOKQuanity ? <>
          <span className="bg-table-status bg-table-text-status">
            {row.reworkOKQuanity}
          </span>
        </> : <span className="bg-table-status bg-table-text-status">
            {"-"}
          </span>
      ),
    },
  ];

  const handleSelectedRowsChange = ({ selectedRows }) => {
    setSelectedRows(selectedRows);
  };
  // const handlePrintClick = () => {
  //   if (selectedRows) {
  //     setOpenViewJobcardCode(true);
  //   }
  // };
  const resetJobcardModal = () => {
    setOpenViewJobcardCode(false);
  };
  return (
    <main className="generatejobcard main" id="main">
      <Row className="justify-center subContent">
        <Col xs={8} md={8} className="rightSide">
          <div className="rightSideInner timesheet">
            <h2 className="mainTitle">
              {"Rework Reports"}
            </h2>
            <p className="subText">
              {"Rework Reports details page"}
            </p>
          </div>
        </Col>
        <Col xs={4} md={4} className="leftSide">
          <Button
            type="button"
            variant="primary"
            size="lg"
            className="btn btn-primary float-right searchFilter-btn"
            onClick={() => setDisplayFilter(!displayFilter)}
          >
            <i class="bi bi-filter"> </i>
          </Button>
        </Col>
        <hr />
      </Row>
      
      <div>
        <ReportList
          selectableRows={false}
          columnsData={columnsData}
          displayProdStatusFilter={displayFilter}
          handleSelections={handleSelectedRowsChange}
          //rowsData={rowsData}
          resetFilerBox={setDisplayFilter}
          pageName={Constants.REPORTS.REWORKREPORTS.pageName}
          pageURL={Constants.REPORTS.REWORKREPORTS.list}
          name={Constants.REPORTS.REWORKREPORTS.name}
        />
      </div>

      {openViewJobcardCode && (
        <PrintStatusReports
          selectedItems={selectedRows}
          show={openViewJobcardCode}
          onHide={() => {
            resetJobcardModal();
          }}
        ></PrintStatusReports>
      )}
    </main>
  );
};

export default ReworkReports;
